export const environment = {
  production: false,
  name: 'dev',
  version: 1.0,
  microConfiguraciones: 'https://dev-api-config.juvomos.com',
  microSeguridades: 'https://dev-api-auth.juvomos.com',
  microReportes: 'https://dev-api-reportes.juvomos.com',
  microNotificaciones: 'https://dev-api-notificaciones.juvomos.com',
  microPerk: 'https://dev-api-perk.juvomos.com',
  microThemes: 'https://dev-api-themes.juvomos.com',
  microEnterprise: 'https://dev-api-enterprise.juvomos.com',
  microMarketing: 'https://dev-api-marketing.juvomos.com',
  microAuditorias: 'https://dev-api-auditoria.juvomos.com',
  microDeliverect: 'https://dev-api-deliverect.juvomos.com',
  oo_billing_account_id: '5494178079440896',
  google_maps_api_key: 'AIzaSyATmQO6h0-2QRhm-0TxkSzGXGk6kmt5UTw'
};
